import React, { useMemo, useState /* , useEffect */ } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Typography,
  Container,
  Grid,
  Button,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { abcdLogoURL, abcdURLSegment, app_title, dhaneshLogoURL, dhaneshURLSegment, digiborrowLogoURL, digiborrowURLSegment, parkPlusLogoURL, parkPlusURLSegment, s3StaticImagePath, lakshyaSkillFinanceLogoURL, lakshyaSkillFinanceURLSegment } from "../config";
import logoutApi from "../hooks/POST/logout";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { defaultUrlSegment } from "../config";
import { removeCookieAsync, removeCreditCardDetailsFromCookie } from "../utils";
import { setProductId, setProductType } from "../utils/reduxSlice/tokenSlice";

export default function GenericHeader() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const authToken = useSelector((state) => state.token.token);
  const logoURL = useSelector((state) => state.appInfo.logo);
  const coBrandLogoURL = useSelector((state) => state.appInfo.coBrandLogoURL);
  const urlSegment = useSelector((state) => state.token.urlSegment);
  const utms = useSelector((state) => state.token.utms);
  // whether to show powered by or not start
  const [showPoweredBy /* , setShowPoweredBy */] = useState(false);
  const pathName = window.location.pathname;
  const showLogout = pathName !== "/verification";

  /* useEffect(() => {
    const intervalFunction = setInterval(() => {
    }, 1000);
    return () => clearInterval(intervalFunction);
  }, []); */
  // whether to show powered by or not end
  const isABCDURL = urlSegment === abcdURLSegment || utms?.utm_id === abcdURLSegment;
  const isDhaneshURL = urlSegment === dhaneshURLSegment || utms?.utm_id === dhaneshURLSegment;
  const isDigiborrowURL = urlSegment === digiborrowURLSegment || utms?.utm_id === digiborrowURLSegment;
  const isParkPlusURL = urlSegment === parkPlusURLSegment || utms?.utm_id === parkPlusURLSegment;
  const isLakshyaSkillFinanceURL = urlSegment === lakshyaSkillFinanceURLSegment || utms?.utm_id === lakshyaSkillFinanceURLSegment;

  const getGenericHeaderLogo = useMemo(() => {
    if(isABCDURL) {
      return abcdLogoURL;
    }
    if(isDhaneshURL) {
      return dhaneshLogoURL;
    }
    if(isDigiborrowURL) {
      return digiborrowLogoURL;
    }
    if(isLakshyaSkillFinanceURL) {
      return lakshyaSkillFinanceLogoURL;
    }
    return logoURL;
  }, [isABCDURL, isDhaneshURL, isDigiborrowURL, isLakshyaSkillFinanceURL, logoURL]);

  // handle logout
  const handleLogout = async () => {
    await logoutApi();
  };

  // handle logo click - navigate back to the home/products page
  const handleLogoClick = async () => {
    await removeCookieAsync("productType");
    dispatch(setProductType(null));
    await removeCookieAsync("productId");
    dispatch(setProductId(null));
    removeCreditCardDetailsFromCookie();
    navigate("/");
  };

  return (
    <AppBar position="sticky" color="inherit" style={{ overflow: "auto" }}>
      <Container maxWidth="xl" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Toolbar disableGutters>
          {/* Desktop part start */}
          <Box sx={{ mr: 2, display: { xs: "none", md: "flex" } }}>
            {!coBrandLogoURL && getGenericHeaderLogo && !isParkPlusURL && <img
              src={getGenericHeaderLogo}
              alt={app_title}
              onClick={handleLogoClick}
              style={{ maxHeight: 75, maxWidth: 202, padding: 5, marginRight: 10, cursor: "pointer" }}
            />}
            {coBrandLogoURL && <img
                src={coBrandLogoURL}
                alt="partner"
                onClick={handleLogoClick}
                style={{ maxHeight: 55, maxWidth: 202, padding: 5, marginRight: 20, objectFit: "contain", cursor: "pointer" }}
            />}
            {(coBrandLogoURL || isABCDURL || isDhaneshURL || isDigiborrowURL || isLakshyaSkillFinanceURL) && (
                <Grid container>
                  <Grid container alignItems="center">
                    <Typography variant="caption" style={{ marginTop: 0 }}>In Partnership With</Typography>
                  </Grid>
                  <Grid container>
                    <img
                        src={logoURL}
                        alt={app_title}
                        onClick={handleLogoClick}
                        style={{ maxWidth: 180, padding: "0 5px 5px 0", marginRight: 10, objectFit: "contain", cursor: "pointer" }}
                    />
                  </Grid>
                </Grid>
            )}

            {/* park plus logo start */}
            {isParkPlusURL && <img
              src={logoURL}
              alt={app_title}
              onClick={handleLogoClick}
              style={{ maxWidth: 180, marginRight: 10, objectFit: "contain", cursor: "pointer" }}
            />}
            {isParkPlusURL && (
              <Grid container>
                <Grid container alignItems="center">
                  <Typography variant="caption" style={{ marginTop: 0 }}>In Partnership With</Typography>
                </Grid>
                <Grid container>
                  <img
                    src={parkPlusLogoURL}
                    alt={app_title}
                    style={{ maxHeight: 45, maxWidth: 202, padding: 5, marginRight: 10 }}
                  />
                </Grid>
              </Grid>
            )}
            {/* park plus logo end */}

            {showPoweredBy && (
              <Grid container>
                <Grid container alignItems="center">
                  <Typography variant="caption">{t("Powered by")}</Typography>
                  <img
                    src={`${s3StaticImagePath}/ongo_logo.png`}
                    alt="powered by"
                    style={{ height: 15, marginLeft: 5 }}
                  />
                </Grid>
                <Grid container>
                  <Typography fontStyle="italic" variant="caption">
                    Dynamic Caption
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }} />

          <Box sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }} />
          {/* Desktop part end */}

          {/* Mobile part start */}
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }} />

          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            {!coBrandLogoURL && getGenericHeaderLogo && !isParkPlusURL && <img
                src={getGenericHeaderLogo}
                alt={app_title}
                onClick={handleLogoClick}
                style={{ maxHeight: 75, maxWidth: 202, padding: 5, marginRight: 10, cursor: "pointer" }}
            />}
            {coBrandLogoURL && <img
                src={coBrandLogoURL}
                alt="partner"
                onClick={handleLogoClick}
                style={{ maxHeight: 55, maxWidth: 130, padding: 5, marginRight: 15, objectFit: "contain", cursor: "pointer" }}
            />}
            {(coBrandLogoURL || isABCDURL || isDhaneshURL || isDigiborrowURL || isLakshyaSkillFinanceURL) && (
                <Grid container>
                  <Grid container alignItems="center">
                    <Typography variant="caption" style={{ marginTop: 0 }}>In Partnership With</Typography>
                  </Grid>
                  <Grid container>
                    <img
                        src={logoURL}
                        alt={app_title}
                        onClick={handleLogoClick}
                        style={{ maxWidth: 160, padding: "0 5px 5px 0", marginRight: 10, objectFit: "contain", cursor: "pointer" }}
                    />
                  </Grid>
                </Grid>
            )}

            {/* park plus logo start */}
            {isParkPlusURL && <img
                src={logoURL}
                alt={app_title}
                onClick={handleLogoClick}
                style={{ maxWidth: 180, marginRight: 10, objectFit: "contain", cursor: "pointer" }}
            />}
            {isParkPlusURL && (
                <Grid container>
                  <Grid container alignItems="center">
                    <Typography variant="caption" style={{ marginTop: 0 }}>In Partnership With</Typography>
                  </Grid>
                  <Grid container>
                    <img
                        src={parkPlusLogoURL}
                        alt={app_title}
                        style={{ maxHeight: 40, maxWidth: 202, padding: 5, marginRight: 10, objectFit: "contain" }}
                    />
                  </Grid>
                </Grid>
            )}
            {/* park plus logo end */}
          </Box>

          <Box sx={{ flexGrow: 0, display: { xs: "flex", md: "none" } }}>
            {showPoweredBy && (
              <Grid container>
                <Grid container alignItems="center">
                  <Typography variant="caption">{t("Powered by")}</Typography>
                  <img
                    src={`${s3StaticImagePath}/ongo_logo.png`}
                    alt="powered by"
                    style={{ height: 15, marginLeft: 5 }}
                  />
                </Grid>
                <Grid container>
                  <Typography fontStyle="italic" variant="caption">
                    Dynamic Caption
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Box>

          {/* Mobile part end */}
        </Toolbar>
        {authToken && showLogout && (<Button
          startIcon={<LogoutIcon />}
          color="error"
          sx={{ alignItems: "start" }}
          onClick={handleLogout}
        >
          {t("Logout")}
        </Button>)}

      </Container>
    </AppBar>
  );
}
